<template>
  <div class="schedule-container">

    <header class="page-header">
      <div class="title-row">
        <div class="title-group">
          <i class="bx bx-time" style="font-size: 28px; color: #0e7490; margin-right: 10px;"></i>
          <h1>
            Расписание ТФ НИЯУ МИФИ (группы) {{ groupNameDisplay }}
          </h1>
        </div>
<!--        <div class="search-box">-->
<!--          <input type="text" placeholder="Группа" />-->
<!--          <button class="search-btn">-->
<!--            <i class="bx bx-search" style="font-size: 20px;"></i>-->
<!--          </button>-->
<!--        </div>-->
      </div>
    </header>

    <nav class="tabs-nav">
      <ul>
        <li
          v-for="tab in tabs"
          :key="tab.id"
          :class="{ active: selectedTabId === tab.id }"
          @click="selectTab(tab.id)"
        >
          {{ tab.name }}
        </li>
      </ul>
    </nav>

    <main class="content-area">
      <h2 class="section-title" v-if="selectedTabId !== 'general'">{{ currentTabName }}</h2>

      <div v-if="selectedTabId === 'today'">
        <div class="schedule-list">
          <div class="day-header">
            <i class="bx bx-chevron-left" style="font-size: 40px; cursor: pointer;" @click="changeDate(-1)"></i>
            <span>{{ formattedHeaderDate }}</span>
            <i class="bx bx-chevron-right" style="font-size: 40px; cursor: pointer;" @click="changeDate(1)"></i>
          </div>

          <div v-if="scheduleStore.loading" class="loading-state">Загрузка...</div>

          <div v-else-if="scheduleStore.todaySchedule && scheduleStore.todaySchedule.length > 0" class="schedule-card">
            <div v-for="(lesson, index) in scheduleStore.todaySchedule" :key="index" class="schedule-row">
              <div class="time-col">
                {{ formatTime(lesson.startTime) }} — {{ formatTime(lesson.endTime) }}
                <span
                  class="week-rect"
                  :class="getWeekTypeClass(lesson.weekType)"
                  :title="getWeekTypeText(lesson.weekType)"
                ></span>
              </div>

              <div class="info-col">
                <div class="lesson-title">
                  <span class="span" :class="getSessionClass(lesson.sessionType)"></span>
                  <span class="span_title" :class="getSessionClass(lesson.sessionType)">
                    {{ getSessionName(lesson.sessionType) }}
                  </span>
                  <span :class="getSessionTextClass(lesson.sessionType)">
                    {{ lesson.subject ? lesson.subject.name : '' }}
                  </span>
                  <div v-for="tutor in lesson.tutors" class="title-teacher" v-if="lesson.tutors" :class="getSessionTextClass(lesson.sessionType)">
                    <i class="bx bxs-graduation" style="margin-right: 5px;"></i> {{ tutor.name }}
                  </div>
                </div>
              </div>

              <div class="location-col">
                <template v-if="lesson.roomId">
                  <i class="bx bxs-map" style="color: #ef4444; font-size: 18px;"></i>
                  <span class="room-number" v-if="lesson.roomId">{{ lesson.roomId }}</span>
                </template>
                <template v-if="lesson.isOnline">
                  <a v-if="lesson.link" :href="lesson.link" target="_blank" class="online-link">
                    <i class="bx bx-link"></i> Ссылка
                  </a>
                  <span style="margin-right: 5px;" class="span_title badge-credit" title="Проводится с использованием дистанционных образовательных технологий">
                      ОНЛ
                   </span>
                </template>
              </div>

            </div>
          </div>
          <div v-else class="empty-state"><p>На эту дату занятий нет.</p></div>
        </div>
      </div>

      <div v-else-if="selectedTabId === 'thisweek'">
        <div class="schedule-list">
          <div class="day-header">
            <i class="bx bx-chevron-left" style="font-size: 40px; cursor: pointer;" @click="changeWeek(-1)"></i>
            <span>{{ formattedWeekRange }}</span>
            <i class="bx bx-chevron-right" style="font-size: 40px; cursor: pointer;" @click="changeWeek(1)"></i>
          </div>

          <div v-if="scheduleStore.loading" class="loading-state">Загрузка недели...</div>

          <div v-else-if="groupedWeekSchedule && Object.keys(groupedWeekSchedule).length > 0">
            <div v-for="(dayLessons, dayNum) in groupedWeekSchedule" :key="dayNum"  :class="{ disabled: isDisabled(dayNum) }" class="week-day-block">
              <div class="week-day-title">
                {{ getDayName(dayNum) }}
              </div>
              <div class="schedule-card">
                <div v-for="(lesson, index) in dayLessons" :key="index" class="schedule-row">
                  <div class="time-col">
                    {{ formatTime(lesson.startTime) }} — {{ formatTime(lesson.endTime) }}
                    <span class="week-rect" :class="getWeekTypeClass(lesson.weekType)"
                          :title="getWeekTypeText(lesson.weekType)"></span>
                  </div>
                  <div class="info-col">
                    <div class="lesson-title">
                      <span class="span" :class="getSessionClass(lesson.sessionType)"></span>
                      <span class="span_title" :class="getSessionClass(lesson.sessionType)">
                        {{ getSessionName(lesson.sessionType) }}
                      </span>
                      <span :class="getSessionTextClass(lesson.sessionType)">
                        {{ lesson.subject ? lesson.subject.name : '' }}
                      </span>
                      <span class="lesson-title-text" :class="getSessionTextClass(lesson.sessionType)">
                        {{ lesson.name }}
                      </span>
                      <div v-for="tutor in lesson.tutors" class="title-teacher" v-if="lesson.tutors" :class="getSessionTextClass(lesson.sessionType)">
                        <i class="bx bxs-graduation" style="margin-right: 5px;"></i> {{ tutor.name }}
                      </div>
                    </div>
                  </div>

                  <div class="location-col">
                    <template v-if="lesson.roomId">
                      <i class="bx bxs-map" style="color: #ef4444; font-size: 18px;"></i>
                      <span class="room-number" v-if="lesson.roomId">{{ lesson.roomId }}</span>
                    </template>
                    <template v-if="lesson.isOnline">
                      <a v-if="lesson.link" :href="lesson.link" target="_blank" class="online-link">
                        <i class="bx bx-link"></i> Ссылка
                      </a>
                      <span style="margin-right: 5px;" class="span_title badge-credit" title="Проводится с использованием дистанционных образовательных технологий">
                          ОНЛ
                       </span>
                    </template>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state"><p>На эту неделю занятий нет.</p></div>
        </div>
      </div>

      <div v-else-if="selectedTabId.startsWith('general-')">
        <div v-if="generalLoading" class="loading-state">Загрузка общего расписания...</div>

        <div v-else-if="Object.keys(groupedGeneralSchedule).length > 0">
          <div v-for="(dayLessons, dayNum) in groupedGeneralSchedule" :key="dayNum" class="week-day-block">
            <div class="week-day-title">
              {{ getDayName(dayNum) }}
            </div>
            <div class="schedule-card">
              <div v-for="(lesson, index) in dayLessons" :key="index" class="schedule-row">
                <div class="time-col">
                  {{ formatTime(lesson.startTime) }} — {{ formatTime(lesson.endTime) }}
                  <span class="week-rect" :class="getWeekTypeClass(lesson.weekType)"
                        :title="getWeekTypeText(lesson.weekType)"></span>
                </div>
                <div class="info-col">
                  <div class="lesson-title">
                    <span class="span" :class="getSessionClass(lesson.sessionType)"></span>
                    <span class="span_title" :class="getSessionClass(lesson.sessionType)">
                        {{ getSessionName(lesson.sessionType) }}
                      </span>
                    <span :class="getSessionTextClass(lesson.sessionType)">
                        {{ lesson.subject ? lesson.subject.name : '' }}
                      </span>
                    <span class="lesson-title-text" :class="getSessionTextClass(lesson.sessionType)">
                        {{ lesson.name }}
                      </span>
                    <div v-for="tutor in lesson.tutors" class="title-teacher" v-if="lesson.tutors" :class="getSessionTextClass(lesson.sessionType)">
                      <i class="bx bxs-graduation" style="margin-right: 5px;"></i> {{ tutor.name }}
                    </div>
                  </div>
                </div>

                <div class="location-col">
                  <template v-if="lesson.roomId">
                    <i class="bx bxs-map" style="color: #ef4444; font-size: 18px;"></i>
                    <span class="room-number" v-if="lesson.roomId">{{ lesson.roomId }}</span>
                  </template>
                  <template v-if="lesson.isOnline">
                    <a v-if="lesson.link" :href="lesson.link" target="_blank" class="online-link">
                      <i class="bx bx-link"></i> Ссылка
                    </a>
                    <span style="margin-right: 5px;" class="span_title badge-credit" title="Проводится с использованием дистанционных образовательных технологий">
                        ОНЛ
                     </span>
                  </template>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div v-else class="empty-state">
          <p>Расписание отсутствует.</p>
        </div>

      </div>

      <div v-else class="columns-grid" v-if="currentItems.length">
        <div class="course-column" v-for="(course, index) in currentItems" :key="index">
          <h3 class="course-header">{{ course.year }}</h3>
          <div class="group-list">
            <button class="group-item" v-for="group in course.list" :key="group.id" @click="handleItemClick(group.id)">
              {{ group.title }}
            </button>
          </div>
        </div>
      </div>

    </main>


  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import axios from 'axios';
import { fetchTodaySchedule, fetchScheduleByDate, fetchWeekSchedule, scheduleStore } from '@/store/schedule';
import { API_URL } from '../server';

// --- SETUP ---
const instance = getCurrentInstance();
const route = (instance && instance.proxy) ? instance.proxy.$route : null;

// --- CONSTANTS ---
const API_BASE_URL = API_URL;

// --- STATE ---
const selectedTabId = ref("today");
const currentGroupId = ref(null);
const currentDate = ref(new Date());
const weekOffset = ref(0);
const todayDay = getDayOfWeekUTCPlus5();


// New State for General Schedule
const generalSubTab = ref('every'); // 'every', 'upper', 'lower'
const generalScheduleData = ref([]);
const generalLoading = ref(false);

const tabs = [
  { id: "general-every", name: "Все недели" },
  { id: "general-upper", name: "Верхняя неделя" },
  { id: "general-lower", name: "Нижняя неделя" },
  { id: "today", name: "Текущий день" },
  { id: "thisweek", name: "Текущая неделя" },
];


// --- 1. MAPPING TEXT BADGES (RU) ---
const getSessionName = (type) => {
  switch(type) {
    case 1: return '';
    case 2: return 'ЛЕК';
    case 3: return 'ПР';
    case 4: return 'ЛАБ';
    case 5: return 'ПЕРЕ';
    case 6: return 'ЭКЗ';
    case 7: return 'КОМ';
    case 8: return 'ЗАЧ';
    default: return '---';
  }
};

function getDayOfWeekUTCPlus5() {
  const now = new Date();

  // UTC time +5 soat
  const utcPlus5 = new Date(now.getTime() + 5 * 60 * 60 * 1000);

  // JS getUTCDay(): 0 (Yakshanba) - 6 (Shanba)
  const utcDay = utcPlus5.getUTCDay();

  // Bizning format: 1 (Dushanba) - 7 (Yakshanba)
  return utcDay === 0 ? 7 : utcDay;
}

function isDisabled(dayNum) {
  if(weekOffset >= 1) {
    return dayNum < todayDay;
  }

  return false;
}


// Add this inside <script setup>
const groupNameDisplay = computed(() => {
  // 1. Try to get from URL Query (Immediate)
  if (route && route.query && route.query.groupName) {
    return route.query.groupName;
  }

  // 2. Fallback: Try to get from loaded store data (After API load)
  if (scheduleStore.todaySchedule &&
    scheduleStore.todaySchedule.length > 0 &&
    scheduleStore.todaySchedule[0].group) {
    return scheduleStore.todaySchedule[0].group.name;
  }

  return '...';
});


// --- 2. MAPPING BACKGROUND CLASSES ---
const getSessionClass = (type) => {
  switch(type) {
    case 1: return '';
    case 2: return 'badge-lecture';
    case 3: return 'badge-practice';
    case 4: return 'badge-lab';
    case 5: return 'badge-retake';
    case 6: return 'badge-exam';
    case 7: return 'badge-commission';
    case 8: return 'badge-credit';
    default: return 'badge-default';
  }
};

const getWeekTypeText = (type) => {
  if (type === 1) return 'Каждую неделю';
  if (type === 2) return 'Верхняя неделя';
  if (type === 3) return 'Нижняя неделя';
  return '';
};


// --- 3. MAPPING TEXT COLOR CLASSES ---
const getSessionTextClass = (type) => {
  switch(type) {
    case 1: return 'text-default';
    case 2: return 'text-lecture';
    case 3: return 'text-practice';
    case 4: return 'text-lab';
    case 5: return 'text-retake';
    case 6: return 'text-exam';
    case 7: return 'text-commission';
    case 8: return 'text-credit';
    default: return 'text-default';
  }
};

// --- LIFECYCLE ---
onMounted(async () => {
  if (route && route.params.id) {
    currentGroupId.value = route.params.id;
    const now = new Date();
    currentDate.value = now;
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const apiDateString = `${year}-${month}-${day}`;
    await fetchScheduleByDate(currentGroupId.value, apiDateString);
  }
});

// --- TAB LOGIC ---
const selectTab = (id) => {
  selectedTabId.value = id;
  if (!currentGroupId.value) return;

  if (id === 'today') {
    currentDate.value = new Date();
    fetchScheduleByDate(currentGroupId.value);
  }

  else if (id === 'thisweek') {
    fetchWeekSchedule(currentGroupId.value, weekOffset.value);
  }

  else if (id.startsWith('general-')) {
    const type = id.replace('general-', '');
    fetchGeneralSchedule(type);
  }
};


// --- GENERAL SCHEDULE LOGIC ---
const fetchGeneralSchedule = async (type) => {
  if (!currentGroupId.value) return;

  generalSubTab.value = type;
  generalLoading.value = true;
  generalScheduleData.value = [];

  let endpoint = '/api/schedule/get-every-weeks';
  if (type === 'upper') endpoint = '/api/schedule/get-upper-weeks';
  if (type === 'lower') endpoint = '/api/schedule/get-lower-weeks';

  try {
    const res = await axios.get(`${API_BASE_URL}${endpoint}?groupId=${currentGroupId.value}`);
    if (res.data && res.data.code === 200) {
      generalScheduleData.value = res.data.data;
    }
  } catch (error) {
    console.error("Failed to fetch general schedule", error);
  } finally {
    generalLoading.value = false;
  }
};

// Helper: Group general schedule by dayOfWeek (1=Mon, etc)
const groupedGeneralSchedule = computed(() => {
  const list = generalScheduleData.value || [];
  if (!list.length) return {};

  const groups = {};
  list.forEach(lesson => {
    // API returns dayOfWeek: 1..7
    const day = lesson.dayOfWeek;
    if (!groups[day]) groups[day] = [];
    groups[day].push(lesson);
  });

  const sortedKeys = Object.keys(groups).sort((a,b) => Number(a) - Number(b));
  const sortedGroups = {};

  sortedKeys.forEach(key => {
    sortedGroups[key] = groups[key];
    sortedGroups[key].sort((a, b) => a.startTime.localeCompare(b.startTime));
  });

  return sortedGroups;
});


// --- DATE LOGIC (TODAY TAB) ---
const changeDate = async (offset) => {
  if (!currentGroupId.value) return;
  const newDate = new Date(currentDate.value);
  newDate.setDate(newDate.getDate() + offset);
  currentDate.value = newDate;
  const year = newDate.getFullYear();
  const month = String(newDate.getMonth() + 1).padStart(2, '0');
  const day = String(newDate.getDate()).padStart(2, '0');
  const apiDateString = `${year}-${month}-${day}`;
  await fetchScheduleByDate(currentGroupId.value, apiDateString);
};

const formattedHeaderDate = computed(() => {
  const d = currentDate.value;
  const days = ['ВОСКРЕСЕНЬЕ', 'ПОНЕДЕЛЬНИК', 'ВТОРНИК', 'СРЕДА', 'ЧЕТВЕРГ', 'ПЯТНИЦА', 'СУББОТА'];
  return `${days[d.getDay()]} , ${formatDateRu(d)}`;
});

// --- WEEK LOGIC (THIS WEEK TAB) ---
const changeWeek = async (offset) => {
  if (!currentGroupId.value) return;
  weekOffset.value += offset;
  await fetchWeekSchedule(currentGroupId.value, weekOffset.value);
};

// *** FIXED GROUPING FOR THIS WEEK (Group by dayOfWeek, not date) ***
const groupedWeekSchedule = computed(() => {
  const list = scheduleStore.weekSchedule || [];
  if (!list.length) return {};

  const groups = {};

  // 1. Group items by dayOfWeek (1, 2, 3...) since date is missing
  list.forEach(lesson => {
    if (lesson.isDeleted) return;

    // FIX: Using dayOfWeek as key
    const dayNum = lesson.dayOfWeek;
    if (!groups[dayNum]) groups[dayNum] = [];
    groups[dayNum].push(lesson);
  });

  // 2. Sort the days (1 -> 6)
  const sortedKeys = Object.keys(groups).sort((a, b) => Number(a) - Number(b));
  const sortedGroups = {};

  // 3. Sort the lessons inside each day (by time)
  sortedKeys.forEach(key => {
    const lessons = groups[key];

    lessons.sort((a, b) => {
      const timeA = a.startTime || '';
      const timeB = b.startTime || '';
      return timeA.localeCompare(timeB);
    });

    sortedGroups[key] = lessons;
  });

  return sortedGroups;
});

const formattedWeekRange = computed(() => {
  const now = new Date();
  let dayOfWeek = now.getDay();
  if (dayOfWeek === 0) dayOfWeek = 7;
  const monday = new Date(now);
  const offsetDays = weekOffset.value * 7;
  monday.setDate(now.getDate() - (dayOfWeek - 1) + offsetDays);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return `${formatDateRu(monday)} — ${formatDateRu(sunday)}`;
});

// --- HELPERS ---
function formatDateRu(dateInput) {
  const d = new Date(dateInput);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${day}-${month}-${year}`;
}

// *** GET DAY NAME (Handles Numbers 1-7) ***
function getDayName(dayNumber) {
  const days = [
    '',
    'ПОНЕДЕЛЬНИК',
    'ВТОРНИК',
    'СРЕДА',
    'ЧЕТВЕРГ',
    'ПЯТНИЦА',
    'СУББОТА',
    'ВОСКРЕСЕНЬЕ'
  ];
  return days[dayNumber] || 'Неизвестно';
}

const getWeekTypeClass = (type) => {
  if (type === 1) return 'week-every';
  if (type === 2) return 'week-upper';
  if (type === 3) return 'week-lower';
  return '';
};


const currentItems = computed(() => {
  const allItems = scheduleStore.items || {};
  return allItems[selectedTabId.value] || [];
});

const currentTabName = computed(() => {
  const tab = tabs.find(t => t.id === selectedTabId.value);
  return tab ? tab.name : '';
});

const handleItemClick = (id) => { console.log(`Navigating to /item/${id}`); };

const formatTime = (timeStr) => {
  if (!timeStr) return '';
  return timeStr.slice(0, 5);
};
</script>

<style scoped>
/* =======================
   RESET / BASE
======================= */
* {
  box-sizing: border-box;
}

/* =======================
   MAIN CONTAINER
======================= */
.schedule-container {
  font-family: 'Segoe UI', sans-serif;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
  min-height: 100dvh; /* mobile-safe vh */
}

.page-header {
  margin-bottom: 30px;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.title-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-group h1 {
  font-weight: 300;
  font-size: 28px;
  margin: 0;
}

/* =======================
   SEARCH
======================= */
.search-box {
  display: flex;
}

.search-box input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  width: 200px;
}

.search-btn {
  background: #0e7490;
  color: white;
  border: none;
  padding: 0 15px;
  cursor: pointer;
}

/* =======================
   TABS
======================= */
.tabs-nav {
  margin-bottom: 30px;
}

.tabs-nav ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  border-bottom: 2px solid #0e7490;
}

.tabs-nav li {
  padding: 12px 20px;
  cursor: pointer;
  color: #555;
  white-space: nowrap;
}

.tabs-nav li.active {
  color: #0e7490;
  font-weight: bold;
  border-bottom: 2px solid #0e7490;
}

/* =======================
   SCHEDULE LIST
======================= */
.schedule-list {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,.05);
  overflow: hidden;
}

.day-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f1f5f9;
  padding: 18px 32px;
  font-size: 18px;
  font-weight: bold;
  color: #475569;
}

.schedule-row {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #eee;
  gap: 15px;
}

.time-col {
  width: 180px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-col {
  flex: 1;
}

.location-col {
  width: 350px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

/* =======================
   TITLES
======================= */
.lesson-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #0e7490;
  flex-wrap: wrap;
}

.lesson-title-text {
  color: #333;
}

.title-teacher {
  color: #666;
  font-size: 13px;
}

/* =======================
   BADGES
======================= */
.span {
  width: 5px;
  height: 24px;
  border-radius: 2px;
}

.span_title {
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
  min-width: 45px;
  text-align: center;
}

/* Badge colors */
.badge-lecture { background-color: #15803d; }
.badge-practice { background-color: #be123c; }
.badge-lab { background-color: #b45309; }
.badge-retake { background-color: #333; }
.badge-exam { background-color: #b91c1c; }
.badge-commission { background-color: #000; }
.badge-credit { background-color: #7c3aed; }
.badge-default { background-color: #64748b; }


/* =======================
   WEEK VIEW
======================= */
.week-day-block {
  margin-bottom: 30px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}

.week-day-title {
  background: #e0f2fe;
  color: #0e7490;
  padding: 10px 16px;
  font-weight: bold;
}

/* =======================
   LOADING / EMPTY
======================= */
.loading-state,
.empty-state {
  padding: 120px 40px;
  text-align: center;
  background: #f9f9f9;
  color: #666;
}

/* =======================
   FOOTER
======================= */
.page-footer {
  margin-left: auto;
  width: 250px;
  padding: 8px 12px;
  background: rgba(255,255,255,.95);
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,.1);
}

/* =======================
   NEW LINK STYLES
======================= */
.online-link {
  display: flex;
  align-items: center;
  color: #0e7490;
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;
  background-color: #e0f2fe;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.online-link:hover {
  background-color: #bae6fd;
  text-decoration: underline;
}

.online-link i {
  font-size: 18px;
  margin-right: 4px;
}

/* =======================
   MOBILE
======================= */
@media (max-width: 768px) {

  .schedule-container {
    max-width: 100%;
    padding: 12px;
  }

  .title-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .title-group h1 {
    font-size: 20px;
  }

  .search-box,
  .search-box input {
    width: 100%;
  }

  .tabs-nav ul {
    overflow-x: auto;
    scrollbar-width: none;
  }

  .schedule-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 12px;
  }

  .time-col,
  .location-col {
    width: 100%;
    justify-content: space-between;
    font-size: 14px;
  }

  .day-header {
    padding: 12px;
    font-size: 15px;
  }

  .loading-state,
  .empty-state {
    padding: 60px 20px;
    font-size: 14px;
  }
}

.week-day-block.disabled {
  opacity: 0.4;
  pointer-events: none;
}

.week-rect {
  width: 16px;
  height: 14px;
  border: 1px solid #eab308;
  background: white;
  display: inline-block;
  box-sizing: border-box;
}
.week-every { background-color: #facc15; }

.week-upper {
  background: linear-gradient(to bottom, #facc15 50%, white 50%);
}

.week-lower {
  background: linear-gradient(to top, #facc15 50%, white 50%);
}
</style>
